import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Portfolio.css";
import { Link } from "react-router-dom";
import SEO from "../SEO";

export default function Portfolio() {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100 });
  }, []);

  const projects = [
    {
      id: 1,
      name: "Clothing E-Commerce Store",
      category: "website",
      icon: "🛍️",
      description:
        "Modern fashion e-commerce website with product catalog and checkout.",
      image: "/img/Anabiyahscollection.png",
      url: "https://anabiyhscollections.com/",
    },
    {
      id: 2,
      name: "Solar Energy Company Website",
      category: "website",
      icon: "☀️",
      description:
        "Solar company website with services and lead generation system.",
      image: "/img/SolidERA-Energy.png",
      url: "http://solidera-energy.com/",
    },
    {
      id: 3,
      name: "Pharmacy Distributor Website",
      category: "website",
      icon: "💊",
      description: "Corporate pharma website with product management system.",
      image: "/img/ags.png",
      url: "https://web.agssukkur.com/",
    },
  ];

  const features = [
    "ERP Development",
    "POS Systems",
    "Inventory Management",
    "E-Commerce Solutions",
    "Business Websites",
    "Mobile Applications",
  ];

  const benefits = [
    "Fast Delivery",
    "Custom Solutions",
    "Scalable Systems",
    "Secure Architecture",
    "24/7 Support",
    "Modern UI/UX",
  ];

  const industries = [
    "Pharmacy Software",
    "Inventory Management",
    "School Management",
    "Restaurant POS",
    "Retail Stores",
    "Supermarkets",
    "Garments Industry",
    "Mobile Shops",
  ];

  const faqs = [
    {
      q: "Do you build custom software?",
      a: "Yes, we develop ERP, POS, websites and mobile applications.",
    },
    {
      q: "Do you provide POS systems?",
      a: "Yes, we provide advanced POS systems for all business types.",
    },
    {
      q: "Can you develop e-commerce websites?",
      a: "Yes, we build secure and scalable online stores.",
    },
  ];

  return (
    <>
      <SEO
        title="Portfolio – MZR Software Projects"
        description="ERP, POS, websites and custom software solutions."
        url="https://mzrsoftware.com/Portfolio/index"
      />

      <section className="portfolio-section">
        {/* HERO */}
        <div className="section-header text-center mb-5" data-aos="fade-up">
          <h1 className="section-title">
            Our <span className="highlight">Portfolio</span>
          </h1>
          <p className="section-subtitle">
            ERP, POS, websites and custom software solutions for modern
            businesses
          </p>
        </div>

        {/* INTRODUCTION */}
        <div className="text-center mb-5" data-aos="fade-up">
          <h2>Introduction</h2>
          <p className="section-subtitle">
            We build scalable and modern business software including ERP
            systems, POS solutions, inventory systems and websites.
          </p>
        </div>

        {/* FEATURES */}
        <div className="container mb-5">
          <h2 className="text-center mb-4" data-aos="fade-up">
            Features
          </h2>

          <div className="portfolio-grid">
            {features.map((item, i) => (
              <div className="portfolio-card" key={i} data-aos="fade-up">
                <div className="card-content text-center">
                  <h3>{item}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* BENEFITS */}
        <div className="container mb-5">
          <h2 className="text-center mb-4" data-aos="fade-up">
            Benefits
          </h2>

          <div className="portfolio-grid">
            {benefits.map((item, i) => (
              <div className="portfolio-card" key={i} data-aos="fade-up">
                <div className="card-content text-center">
                  <h3>{item}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* SCREENSHOTS (UNCHANGED STYLE) */}
        <div className="container mb-5">
          <h2 className="text-center mb-4" data-aos="fade-up">
            Screenshots
          </h2>

          <div className="portfolio-grid">
            {projects.map((project) => {
              const isExternal = project.url.startsWith("http");

              const Card = (
                <div className="portfolio-card" data-aos="fade-up">
                  <div className="card-image-wrapper">
                    <img
                      src={project.image}
                      alt={project.name}
                      className="project-image"
                    />

                    <div className="card-overlay">
                      <span className="project-icon">{project.icon}</span>
                      <span className="visit-icon">🔗 View</span>
                    </div>
                  </div>

                  <div className="card-content">
                    <h3 className="card-title">{project.name}</h3>
                    <span className="category-badge">{project.category}</span>
                    <p className="card-description">{project.description}</p>
                  </div>
                </div>
              );

              return isExternal ? (
                <a
                  key={project.id}
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="portfolio-link"
                >
                  {Card}
                </a>
              ) : (
                <Link
                  key={project.id}
                  to={project.url}
                  className="portfolio-link"
                >
                  {Card}
                </Link>
              );
            })}
          </div>
        </div>

        {/* INDUSTRIES (CLEAN BOX GRID) */}
        <div className="container mb-5">
          <h2 className="text-center mb-4" data-aos="fade-up">
            Industries We Serve
          </h2>

          <div className="portfolio-grid">
            {industries.map((item, i) => (
              <div
                className="portfolio-card text-center"
                key={i}
                data-aos="zoom-in"
              >
                <div className="card-content">
                  <h3>{item}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ */}
        <div className="container mb-5">
          <h2 className="text-center mb-4" data-aos="fade-up">
            FAQs
          </h2>

          <div className="portfolio-grid">
            {faqs.map((faq, i) => (
              <div className="portfolio-card" key={i} data-aos="fade-up">
                <div className="card-content">
                  <h3>{faq.q}</h3>
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="portfolio-cta text-center mt-5" data-aos="fade-up">
          <h2>Ready to Build Your Software?</h2>
          <p className="cta-text">
            Let’s create ERP, POS or custom business solutions for your company.
          </p>

          <Link to="/contact" className="btn-primary">
            Get Started Today →
          </Link>
        </div>
      </section>
    </>
  );
}
